import React from "react";

const UndoIcon = () => {
  return (
    <svg
      id="control-undo"
      className="control__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.2 11.3"
    >
      <path d="M6 0v3.2s2.9 0 4.1.5 3.1 1.5 3.1 3.9-1 3.9-1.5 3.6c-.5-.3-.2-.7-.1-.9 0-.1 1.4-3.1-2.5-3.8-1.2 0-3.1.1-3.1.1v3.2L0 4.9 6 0z" />
    </svg>
  );
};

export default UndoIcon;
